import * as React from "react"
import { cn } from "@/lib/utils"
import { useDirectionStore } from "@/store/directionStore"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const direction = useDirectionStore(s => s.direction)
    const overlay =
      direction === 'command' ? 'font-mono !text-[13px] bg-secondary/50' :
      direction === 'saas' ? 'h-8 !text-[13px] shadow-none' :
      direction === 'expressive' ? 'rounded-xl bg-glass' :
      ''
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background dark:bg-muted/40 px-3 py-2 text-body ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          overlay,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
